import React from 'react';
import TERMS from '../assets/documents/terms.pdf';
import './styles/terms.scss';

function TermsView() {
  return (
    <div>
      <embed className="Terms" src={TERMS} />
    </div>
  );
}

export default TermsView;
